import React from "react";
import { searchReducer, initialState } from "./reducer";
import useThunkReducer from "../../HOC/useThunkReducer";

export const SearchContext = React.createContext();

const SearchWrapper = ({ children }) => {
  const [searchState, dispatch] = useThunkReducer(
    searchReducer,
    initialState
  );

  const value = {
    searchState,
    dispatch,
  };
  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
};

export default SearchWrapper;
